import React from 'react'
import { Link } from 'react-router-dom'
import { BaseProps } from '../Text'

export function Base({
  inline,
  element,
  children,
  href,
  to,
  ...props
}: BaseProps) {
  if (to) {
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    )
  }
  // eslint-disable-next-line no-nested-ternary
  const _element = element || href ? 'a' : inline ? 'span' : 'div'
  return React.createElement(
    _element,
    {
      href,
      ...props,
    },
    children
  )
}
